import axios from "axios";

export default {
    complete(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    createStore(data) {
        return axios({
            method: "post",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey/store",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getStore(storeId) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey/store/" + storeId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSurveyPending() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey/pending",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllByProfessional(professionalId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/survey/professional/" +
                professionalId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllByOrganizationStore() {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/surveys/store",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllExcelByOrganizationComparativeGalatea(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/surveys/store/organization/" +
                organizationId +
                "/galatea/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllExcelByOrganization(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/surveys/store/organization/" +
                organizationId +
                "/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllExcelByOrganizationGalatea(organizationId, data) {
        return axios({
            method: "post",
            responseType: "blob",
            data: data,
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/surveys/store/organization/" +
                organizationId +
                "/galatea/all/excel",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllByPatientStore(patientId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/surveys/store/patient/" +
                patientId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getTemplate(uuid) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE + "auth/survey/questionary/" + uuid,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSurvey(surveyId) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey/" + surveyId,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSurveyEngines(surveyId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/survey/" +
                surveyId +
                "/engines",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSurveysBySurveyStore(currentPage = 0, pageSize = 10, surveyStoreId) {
        return axios({
            method: "get",
            url:
                process.env.VUE_APP_BASE_URL_CORE +
                "auth/surveys/store/" +
                surveyStoreId +
                "/surveys?page=" +
                currentPage +
                "&size=" +
                pageSize,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    cloneTemplate(data) {
        return axios({
            method: "put",
            data: data,
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/survey/tab/clone",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
